// @flow
if (!process.env.REACT_APP_ACE_API)
  throw new Error('REACT_APP_ACE_API missing');
if (!process.env.REACT_APP_PUBLIC_ACE_API)
  throw new Error('REACT_APP_PUBLIC_ACE_API missing');
if (!process.env.REACT_APP_BOX_API)
  throw new Error('REACT_APP_BOX_API missing');
if (!process.env.REACT_APP_LOGIN_API)
  throw new Error('REACT_APP_LOGIN_API missing');
if (!process.env.REACT_APP_LOGIN_VERIFY_API)
  throw new Error('REACT_APP_LOGIN_VERIFY_API missing');
if (!process.env.REACT_APP_QUESTIONNAIRE_API)
  throw new Error('REACT_APP_QUESTIONNAIRE_API missing');
if (!process.env.REACT_APP_USER_API)
  throw new Error('REACT_APP_USER_API missing');
if (!process.env.REACT_APP_ADD_ONS_API)
  throw new Error('REACT_APP_ADD_ONS_API missing');
if (!process.env.REACT_APP_CUSTOMIZE_API)
  throw new Error('REACT_APP_CUSTOMIZE_API missing');
if (!process.env.REACT_APP_AVATAR_API)
  throw new Error('REACT_APP_AVATAR_API missing');
if (!process.env.REACT_APP_IMG_BASE_PATH)
  throw new Error('REACT_APP_IMG_BASE_PATH missing');
if (!process.env.REACT_APP_HOSTNAME)
  throw new Error('REACT_APP_HOSTNAME missing');
if (!process.env.REACT_APP_EROS_S3_URL)
  throw new Error('REACT_APP_EROS_S3_URL missing');
if (!process.env.REACT_APP_API_URL)
  throw new Error('REACT_APP_API_URL missing');
if (!process.env.REACT_APP_LAUNCH_DARKLY)
  throw new Error('REACT_APP_LAUNCH_DARKLY missing');
if (!process.env.REACT_APP_OPTIMIZELY)
  throw new Error('REACT_APP_OPTIMIZELY missing');
if (!process.env.REACT_APP_CUSTOMIZE_PATH)
  throw new Error('REACT_APP_CUSTOMIZE_PATH missing');
if (!process.env.REACT_APP_LOCALIZATION_API)
  throw new Error('REACT_APP_LOCALIZATION_API missing');
if (!process.env.REACT_APP_GROWTH_API)
  throw new Error('REACT_APP_GROWTH_API missing');
if (!process.env.REACT_APP_RECURLY_PUBLIC_KEY)
  throw new Error('REACT_APP_RECURLY_PUBLIC_KEY missing');
if (!process.env.REACT_APP_REVENUE_API)
  throw new Error('REACT_APP_REVENUE_API missing');
if (!process.env.REACT_APP_INVITATION_API)
  throw new Error('REACT_APP_INVITATION_API missing');
if (!process.env.REACT_APP_SEGMENT)
  throw new Error('REACT_APP_SEGMENT missing');
if (!process.env.REACT_APP_REGISTER_API)
  throw new Error('REACT_APP_REGISTER_API missing');
if (!process.env.REACT_APP_FACEBOOK_APP_ID)
  throw new Error('REACT_APP_FACEBOOK_APP_ID missing');
if (!process.env.REACT_APP_PAYMENT_API)
  throw new Error('REACT_APP_PAYMENT_API missing');
if (!process.env.REACT_APP_HOTJAR_HJID)
  throw new Error('REACT_APP_HOTJAR_HJID missing');
if (!process.env.REACT_APP_HOTJAR_HJSV)
  throw new Error('REACT_APP_HOTJAR_HJSV missing');

const aceApi: string = process.env.REACT_APP_ACE_API;
const publicAceApi: string = process.env.REACT_APP_PUBLIC_ACE_API;
const questionnaireApi: string = process.env.REACT_APP_QUESTIONNAIRE_API;
const boxEndpoint: string = process.env.REACT_APP_BOX_API;
const loginEndpoint: string = process.env.REACT_APP_LOGIN_API;
const loginVerifyEndpoint: string = process.env.REACT_APP_LOGIN_VERIFY_API;
const userEndpoint: string = process.env.REACT_APP_USER_API;
const addOnsEndpoint: string = process.env.REACT_APP_ADD_ONS_API;
const customizeEndpoint: string = process.env.REACT_APP_CUSTOMIZE_API;
const avatarApi: string = process.env.REACT_APP_AVATAR_API;
const localizationEndpoint: string = process.env.REACT_APP_LOCALIZATION_API;
const growthApi: string = process.env.REACT_APP_GROWTH_API;
const imgBasePath: string = process.env.REACT_APP_IMG_BASE_PATH;
const hostname: string = process.env.REACT_APP_HOSTNAME;
const erosURL: string = process.env.REACT_APP_EROS_S3_URL;
const apiURL: string = process.env.REACT_APP_API_URL;
const launchDarkly: string = process.env.REACT_APP_LAUNCH_DARKLY;
const optimizely: string = process.env.REACT_APP_OPTIMIZELY;
const segment: string = process.env.REACT_APP_SEGMENT;
const customizePath: string = process.env.REACT_APP_CUSTOMIZE_PATH;
const zendeskKey = process.env.REACT_APP_ZENDESK;
const recurlyPublicKey = process.env.REACT_APP_RECURLY_PUBLIC_KEY;
const revenueApi = process.env.REACT_APP_REVENUE_API;
const invitationApi = process.env.REACT_APP_INVITATION_API;
const registerApi = process.env.REACT_APP_REGISTER_API;
const refillsApi = process.env.REACT_APP_REFILLS_API;
const fbAppId = process.env.REACT_APP_FACEBOOK_APP_ID;
const paymentApi = process.env.REACT_APP_PAYMENT_API;
const storefrontApi = process.env.REACT_APP_STOREFRONT_API;
const hotjarID = process.env.REACT_APP_HOTJAR_HJID;
const hotjarSV = process.env.REACT_APP_HOTJAR_HJSV;
const datadogLogsId = process.env.REACT_APP_DATADOG_LOGS;
const datadogRumAppId = process.env.REACT_APP_DATADOG_RUM_APP_ID;
const datadogRumClientToken = process.env.REACT_APP_DATADOG_RUM_CLIENT_TOKEN;
const appEnv = process.env.REACT_APP_ENV;

export default {
  aceApi,
  publicAceApi,
  box: boxEndpoint,
  user: userEndpoint,
  addOns: addOnsEndpoint,
  login: loginEndpoint,
  loginVerify: loginVerifyEndpoint,
  customize: customizeEndpoint,
  avatarApi,
  localization: localizationEndpoint,
  growth: growthApi,
  imgBaseUrl: imgBasePath,
  customizePath,
  hostname,
  erosURL,
  apiURL,
  launchDarkly,
  optimizely,
  segment,
  zendeskKey,
  appEnv,
  recurlyPublicKey,
  revenueApi,
  invitationApi,
  registerApi,
  refillsApi,
  fbAppId,
  paymentApi,
  storefrontApi,
  hotjarID,
  hotjarSV,
  questionnaireApi,
  datadogLogsId,
  datadogRumAppId,
  datadogRumClientToken,
};
